// Team people (TD-099, TD-106): the badge on someone outside the agency, and Add freelancer's checks, request and toast, pure
// so they can be tested.
import { ENTITY_CONFIG } from "@/core/entityConfig";
import type { AddedFreelancer, FreelancerInput } from "../types";

/** The badge on someone with no membership in the agency (TD-106). */
export const EXTERNAL = "External";

// As wide as people.email and people.name on the server.
const EMAIL_MAX = 320;
const NAME_MAX = 255;
const freelancerWord = ENTITY_CONFIG.freelancer.label.toLowerCase();

export const FREELANCER_INTRO = `A ${freelancerWord} is someone you pay who is not on the team. They never sign in and see nothing.`;

export interface FreelancerCheck {
  nameError: string | null;
  emailError: string | null;
  blocked: boolean;
}

/** Add freelancer's checks, as the server makes them: an email with an @, at most 320 characters, a name of at most 255. */
export function freelancerCheck(name: string, email: string): FreelancerCheck {
  const typed = email.trim();
  const emailError = typed.includes("@") && typed.length <= EMAIL_MAX ? null : "Enter a valid email";
  const nameError = name.trim().length > NAME_MAX ? `The name must be ${NAME_MAX} characters or fewer` : null;
  return { nameError, emailError, blocked: emailError !== null || nameError !== null };
}

export const freelancerInput = (name: string, email: string): FreelancerInput => ({ name: name.trim() || null, email: email.trim() });

/** Add freelancer's toast. A name another agency gave them stays (TD-086), and the toast says so. */
export const addedToast = (p: AddedFreelancer): string =>
  p.nameApplied ? `${p.name} added.` : `${p.name} added. Another agency named them, so their name stays.`;
